import { useState, memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

import { theme } from '_constants/theme';
import { ICONS_ALIASES } from '_constants/icons';
import { getBlogTags } from '_helpers/blog';

import * as Layout from '_components/atomic/layouts';
import Accordion from '_components/atomic/Accordion';
import Icon from '_components/atomic/Icon';
import Button from '_components/atomic/Button';
import Checkbox from './Checkbox';
import SearchInput from './SearchInput';

const StyledContainer = styled.div`
  button {
    justify-content: center;
    width: 100%;
    margin-bottom: ${theme.spaces.regular}px;
  }

  @media ${theme.devices.tablet} {
  }
`;

const StyledTitleContainer = styled.div`
  padding-top: ${theme.spaces.regular}px;
  padding-bottom: ${theme.spaces.regular}px;
`;

const StyledTagsContainer = styled.div``;

const StyledTag = styled.div``;

const TopicsFilter = ({ onChange }) => {
  const [search, setSearch] = useState('');
  const [selectedTags, setSelectedTags] = useState(getBlogTags());

  const handleSelectAll = (e) => {
    const { value } = e.target;

    if (value) {
      setSelectedTags(getBlogTags());
    } else {
      setSelectedTags([]);
    }
  };

  const handleTagSelect = (e) => {
    const { name, value } = e.target;

    setSelectedTags((prevSelectedTags) => {
      if (value) {
        return [...prevSelectedTags, name];
      } else {
        return prevSelectedTags.filter(
          (prevSelectedTag) => prevSelectedTag !== name
        );
      }
    });
  };

  const handleApply = () => {
    onChange && onChange(selectedTags);
    setSearch('');
  };

  const handleSearchInputChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchChange = (e) => {
    setSelectedTags(getBlogTags(e.target.value));
    onChange && onChange(getBlogTags(e.target.value));
  };

  return (
    <StyledContainer>
      <SearchInput
        value={search}
        onInputChange={handleSearchInputChange}
        onChange={handleSearchChange}
      />
      <Accordion
        openIcon={
          <Icon
            alias={ICONS_ALIASES.chevronUp}
            color={theme.colors.gray[800]}
            height={18}
            width={18}
          />
        }
        closeIcon={
          <Icon
            alias={ICONS_ALIASES.chevronDown}
            color={theme.colors.gray[800]}
            height={18}
            width={18}
          />
        }
        items={[
          {
            openByDefault: !isMobile,
            title: (
              <StyledTitleContainer>
                <Layout.Card.Text
                  size={theme.fontSizes.medium}
                  boldest
                  noBottomSpace
                  desktop
                >
                  All categories
                </Layout.Card.Text>
                <Layout.Card.Text
                  size={theme.fontSizes.regular}
                  boldest
                  noBottomSpace
                  mobile
                >
                  All categories
                </Layout.Card.Text>
              </StyledTitleContainer>
            ),
            body: (
              <div>
                <StyledTagsContainer>
                  <StyledTag>
                    <Checkbox
                      value={getBlogTags().length === selectedTags.length}
                      label="All"
                      onChange={handleSelectAll}
                    />
                  </StyledTag>
                  {getBlogTags().map((tag) => (
                    <StyledTag key={tag}>
                      <Checkbox
                        name={tag}
                        value={selectedTags?.includes(tag)}
                        label={tag}
                        onChange={handleTagSelect}
                      />
                    </StyledTag>
                  ))}
                </StyledTagsContainer>
                <Button color={theme.colors.indigo[600]} onClick={handleApply}>
                  Apply
                </Button>
              </div>
            ),
          },
        ]}
      />
    </StyledContainer>
  );
};

TopicsFilter.propTypes = {
  onChange: PropTypes.func,
};

export default memo(TopicsFilter);
